import React from 'react';
import { useDispatch } from 'react-redux';
import { logout } from '../../store/authentication/actions';

export function LogOut() {
    const dispatch = useDispatch();

    dispatch(logout() as any);

    return <>Logging out...</>;
}
